import script from "./MainFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./MainFooter.vue?vue&type=script&setup=true&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=3de17e12&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de17e12"]])

export default __exports__